import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from 'App';
import reportWebVitals from 'reportWebVitals';
import { AuthProvider } from 'helpers/AuthProvider';
import './i18n/i18n';

const Wrapper = window.Cypress ? React.Fragment : React.StrictMode;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Wrapper>
    <AuthProvider>
      <App />
    </AuthProvider>
  </Wrapper>,
);

// If you want to start measuring performance in your app, pass a function
// to log results
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
